var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCapital(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 81,
    viewBox: "0 0 251 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.236 48.2951L162.476 53.6726H160.099L155.653 49.1236H154.964V53.6726H153.069V42.9747H154.964V47.5366H155.653L159.859 42.985H162.154L157.236 48.2951Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.384 50.7651H165.712L164.523 53.6726H162.551L167.077 42.9747H169.008L173.536 53.6726H171.561L170.384 50.7651ZM169.725 49.1987L168.07 45.1003L166.365 49.1987H169.725Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184.803 53.6726H182.913V44.611H177.227V53.6726H175.335V42.9747H184.803V53.6726Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.972 53.6726V42.9747H189.866V50.9463L195.708 42.9747H197.603V53.6726H195.708V45.7035L189.866 53.6726H187.972Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M209.172 44.6032H205.289V53.6648H203.394V44.6032H199.533V42.9747H209.164L209.172 44.6032Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.429 50.7651H211.759L210.571 53.6726H208.596L213.124 42.9747H215.055L219.595 53.6726H217.62L216.429 50.7651ZM215.772 49.1987L214.117 45.1003L212.424 49.1987H215.772Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M230.089 53.6726H228.194V44.611H224.333L224.236 49.9133C224.19 52.2435 223.133 53.6804 220.706 53.6804H219.904V51.9794L220.706 51.9638C222.151 51.9328 222.311 51.0137 222.328 49.9755L222.471 42.9851H230.081L230.089 53.6726Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6868 38.117C87.739 38.521 88.6807 39.0674 89.4432 39.7638C90.2056 40.4949 90.8195 41.3722 91.2922 42.361C91.7268 43.3499 91.9441 44.4465 91.9441 45.6546C91.9441 46.8628 91.7268 47.9247 91.2922 48.9097C90.8195 49.8986 90.2056 50.7758 89.4432 51.4722C88.6807 52.2033 87.739 52.7535 86.6868 53.1537C85.6003 53.5577 84.4375 53.777 83.1718 53.777H70.5107V27.7976H89.7329V32.8458H75.8024V37.5283H83.1718C84.4413 37.5322 85.6003 37.7169 86.6868 38.117ZM85.8176 43.2421C85.1276 42.6919 84.224 42.3994 83.0993 42.3994H75.8024V48.8751H83.0993C84.224 48.8751 85.1276 48.5827 85.8176 48.0324C86.5077 47.4822 86.8317 46.7166 86.8317 45.6546C86.8317 44.5927 86.5077 43.7885 85.8176 43.2421Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.822 53.777H96.7527V27.7976H101.822V38.8096L110.838 27.7976H117.14L106.857 40.2755L119.285 53.777H112.666L101.822 41.9955V53.777Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.075 53.1241C125.441 52.4291 124.024 51.4807 122.824 50.275C121.625 49.0693 120.682 47.6832 119.991 46.0398C119.3 44.3965 118.975 42.6456 118.975 40.7833C118.975 38.9211 119.303 37.1702 119.991 35.5269C120.682 33.8835 121.625 32.4589 122.824 31.2533C124.024 30.0476 125.441 29.0992 127.075 28.4043C128.71 27.7093 130.524 27.3829 132.487 27.3829C133.938 27.3829 135.355 27.6018 136.699 28.0395C138.043 28.5156 139.277 29.1338 140.404 29.9401C141.492 30.781 142.439 31.7294 143.237 32.8622C144.035 33.9949 144.616 35.2734 144.979 36.6595H139.277C139.021 36.003 138.658 35.4193 138.188 34.9086C137.715 34.398 137.173 33.9603 136.554 33.5955C135.935 33.2653 135.32 32.9734 134.629 32.793C133.938 32.6087 133.212 32.5012 132.487 32.5012C131.253 32.5012 130.127 32.7201 129.145 33.1232C128.129 33.5609 127.258 34.1445 126.529 34.9125C125.803 35.6804 125.257 36.5559 124.86 37.5427C124.459 38.5295 124.28 39.6238 124.28 40.791C124.28 41.9583 124.463 43.0564 124.86 44.0394C125.261 45.0262 125.803 45.9017 126.529 46.6696C127.255 47.4375 128.125 48.0212 129.145 48.4205C130.127 48.8582 131.253 49.0771 132.487 49.0771C133.212 49.0771 133.938 48.9657 134.629 48.7853C135.32 48.6009 135.935 48.3092 136.554 47.9444C137.173 47.6142 137.715 47.1764 138.188 46.6657C138.662 46.1551 139.025 45.5714 139.277 44.9148H144.979C144.616 46.301 144.035 47.545 143.237 48.6739C142.439 49.8066 141.496 50.7933 140.404 51.5958C139.277 52.4367 138.043 53.055 136.699 53.4965C135.355 53.9727 133.938 54.1914 132.487 54.1914C130.528 54.1838 128.71 53.8191 127.075 53.1241Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8962 61C50.955 61 59.9199 52.0457 59.9199 41C59.9199 29.9543 50.955 21 39.8962 21C28.8375 21 19.8726 29.9543 19.8726 41C19.8726 52.0457 28.8375 61 39.8962 61Z",
    fill: "url(#paint0_linear_17_1193)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9559 24.4152C22.2988 30.4636 23.0212 41.3612 30.5716 48.7531C38.1193 56.145 49.634 57.2366 56.2938 51.1856C57.0483 50.5 57.708 49.7523 58.2739 48.9545C59.333 46.5167 59.9202 43.8268 59.9202 41C59.9202 29.9543 50.9553 21 39.8965 21C36.1744 21 32.6894 22.0144 29.7037 23.7815C29.4482 23.9832 29.1988 24.1944 28.9559 24.4152Z",
    fill: "url(#paint1_radial_17_1193)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3154 24.414C27.1645 29.207 30.834 36.6557 38.5123 41.0465C46.1907 45.4399 54.9668 45.1139 58.1203 40.3182C59.0108 38.9639 59.3572 37.398 59.2229 35.7492C56.914 27.2506 49.136 21 39.8964 21C37.1061 21 34.4491 21.5701 32.0358 22.5999C31.3562 23.1088 30.7757 23.7137 30.3154 24.414Z",
    fill: "url(#paint2_radial_17_1193)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17_1193",
    x1: 50.7151,
    y1: 85.859,
    x2: 37.1134,
    y2: -4.57742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303516,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733277,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_17_1193",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.8419 42.7105) rotate(106.278) scale(36.1876 30.4648)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279744,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.450971,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_17_1193",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.6319 13.6694) rotate(53.1036) scale(50.7038 56.5649)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136507,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397079,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725487,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapital);
export default __webpack_public_path__ + "static/media/capital.7b236b01231f8f705621ac8ff19a0397.svg";
export { ForwardRef as ReactComponent };